<div
  class="mt-2 bg-better-deal color-light align-items-center p-3 layout-auto-fr gap-3 border-radius-3">
  <div>
    @if (isBiggestSaving) {
      <shared-icon class="fill-light" icon="star" width="1.5rem" height="1.5rem" />
    } @else {
      <shared-icon class="fill-light" icon="pig" width="1.5rem" height="1.5rem" />
    }
  </div>
  <div class="text-12 deal-message">
    This switch could lower your monthly payments by
    {{ (savedOnInitialRatePayment | currency: "GBP" : "symbol" : "1.0-0") || "-" }}
    and
    <b>
      save you up to
      {{ (savingsInComparisonPeriod | currency: "GBP" : "symbol" : "1.0-0") || "-" }}
    </b>
    over {{ comparisonPeriod }} months.
  </div>
</div>
